var EHDI = EHDI || Object.create(null);

EHDI.localization = EHDI.localization || Object.create(null);

EHDI.localization.LocalizationXMLReader = function(xmlString) {
    var result = xmlString.getElementsByTagName("item");
    EHDI.localization.strings = EHDI.localization.strings || Object.create(null);
    for(var i = 0; i < result.length; i++) {
        EHDI.localization.strings[result[i].getAttribute("id")] = {
            content : result[i].textContent, 
            size : parseInt(result[i].getAttribute("size"))
        };
    }
    
}; 